import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'

import Hub from 'base/hub'
import Event from 'base/event'
import Button from '@everlane/button'
import googleConnect from 'base/lib/google_connect'
import ImageHelper from 'base/lib/image_helper'
import { updateVisitor } from 'base/actions/synchronous'

const GOOGLE_ICON_URL = 'i/5c439b13_4155.png'
const GOOGLE_BUTTON_TEXT = 'Connecting…'

class GoogleConnectButton extends Component {
  static propTypes = {
    buttonText: PropTypes.string,
    onClick: PropTypes.func,
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    className: PropTypes.string,
    fullWidth: PropTypes.bool,
    siteLocation: PropTypes.string,
    disabled: PropTypes.bool,
    showIcon: PropTypes.bool,
  }

  static defaultProps = {
    buttonText: 'Google',
    showIcon: false,
  }

  state = {
    isLoading: false,
  }

  handleClick = () => {
    this.setState({ isLoading: true })
    Hub.pub(Event.Login.GOOGLE_BUTTON)

    googleConnect({
      siteLocation: this.props.siteLocation,
    })
      .then(session => {
        this.setState({ isLoading: false })
        Hub.pub(Event.User.SIGN_IN, {
          siteLocation: this.props.siteLocation,
        })
        this.props.updateVisitor(session.visitor)
        this.props.onSuccess &&
          this.props.onSuccess({
            isNewUser: !!session.user.just_created,
          })
      })
      .catch(errorMessage => {
        this.setState({ isLoading: false })
        return typeof this.props.onError === 'function' ? this.props.onError(errorMessage) : 0
      })
  }

  renderIcon = () => {
    return (
      <div>
        <img
          src={ImageHelper.imageUrl(GOOGLE_ICON_URL)}
          alt="Log in with Google"
          className="google-connect-button__cta-icon"
        />
        <span className="google-connect-button__cta-text">{this.props.buttonText}</span>
      </div>
    )
  }

  render() {
    const { disabled } = this.props
    const className = classNames(this.props.className, {
      'google-connect-button__button--icon': this.props.showIcon,
    })

    return (
      <Button disabled={disabled} onClick={this.handleClick} className={className}>
        {this.state.isLoading
          ? GOOGLE_BUTTON_TEXT
          : this.props.showIcon
          ? this.renderIcon()
          : this.props.buttonText}
      </Button>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    updateVisitor: visitor => dispatch(updateVisitor(visitor)),
  }
}

export default connect(null, mapDispatchToProps)(GoogleConnectButton)
